<template>
  <div
    v-if="config"
    class="directory-widget"
  >
    <dashboard-widget-header
      v-if="config.name"
      :free-items-count="freeItemsCount"
      :icon="widgetIcon"
      :show-free-counts="showFreeCounts"
      :total-display-name="totalDisplayName"
      :total-items-count="totalItemsCount"
      :title="config.name"
    />
    <div class="nine-grid-container">
      <ul>
        <li
          v-for="item in navigationItems"
          :key="item.id"
        >
          <router-link
            :to="item.route"
            @click.native="sendAnalytics(item)"
          >
            <img
              :src="item.icon"
              role="presentation"
              alt=""
            >
            <div class="text">
              <div class="name">
                {{ item.name }}
              </div>
              <div :class="[{ locked: locked(item) }, 'counts']">
                <template v-if="showFreeLabel(item)">
                  <span>{{ item.accessibleItemsCount($store, $access) }} Free</span> of
                </template>
                {{ item.totalItemsCount($store) }} {{ itemDisplayName(item) }}
                <icon
                  v-if="locked(item) "
                  name="lock"
                  variant="b3b3b3"
                />
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import Icon from '@components/singletons/icon';

import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import GlobalMixin from '@/mixins/global';

import { displayName } from '@/utils';

export default {
  components: { DashboardWidgetHeader, Icon },
  mixins: [DashboardWidgetMixin, GlobalMixin],
  props: {
    config: {
      type: Object,
    },
  },
  methods: {
    itemDisplayName(item) {
      const count = item.totalItemsCount(this.$store);
      return displayName(count);
    },
    locked(item) {
      return item.locked(this.$store, this.$access);
    },
    sendAnalytics(item) {
      this.$analytics.events.selectedNavItem(item, this.navigationGroup, this.config.widgetType);
    },
    showFreeLabel(item) {
      return item.showFreeLabel(this.$store, this.$access);
    },
  },
};
</script>

<style lang='scss' scoped>
.directory-widget {
  @include padded-widget;

  .nine-grid-container {
    padding-left: rem-calc(32);
    padding-right: rem-calc(32);

    ul {
      box-sizing: border-box;
      column-fill: balance;
      list-style-type: none;
      column-count: 3;
      width: 100%;
      padding-left: 0;

      @include breakpoint(medium) {
        column-count: 2;
      }

      @include breakpoint(small) {
        column-count: 1;
      }

      > li {
        padding: 8px;
        width: 100%;
        display: inline-block;
        a {
          align-items: center;
          display: flex;

          img {
            height: rem-calc(16);
            margin-bottom: rem-calc(3);
            width: rem-calc(16);
          }
        }
      }
    }

    .text {
      border-bottom: 1px solid transparent;
      color: black;
      font-size: rem-calc(14);
      margin-left: rem-calc(12);

      &:hover {
        .name {
          text-decoration: underline;
        }
      }

      .name {
        font-size: rem-calc(12);
      }

      .counts {
        font-size: rem-calc(10);
        margin-top: rem-calc(3);

        &.locked {
          color: #b3b2b3;
        }

        span {
          font-weight: $bold;
        }

        img {
          display: inline-block;
          height: rem-calc(8);
          margin-left: rem-calc(1);
          width: rem-calc(8);
        }
      }
    }
  }
}
</style>
